import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import * as r from './styles';
import * as s from '../styles';

const Checkbox = ({ data, index, filterIndex, handleChange, style }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref && ref.current.shadowRoot) {
      const label = ref.current.shadowRoot.querySelector('label');
      const span = ref.current.shadowRoot.querySelector('label > span');
      if (label) {
        label.style.display = 'flex';
        label.style.alignItems = 'center';

        span.style.lineHeight = '13px';
        span.style.fontSize = '14px';
      }
    }
  }, [ref]);

  return (
    <r.ListItem className={index % 2 ? 'ListItemOdd' : 'ListItemEven'} style={style}>
      <s.CustomCheckbox
        ref={ref}
        className="inverse"
        label={data[index]?.label}
        value={data[index]?.value}
        aria-label={data[index]?.label}
        checked={data[index]?.isSelected}
        onSomaChange={() => handleChange(filterIndex, data[index]?.value)/* setItems(filterIndex, data[index].value, e.detail) */}
      />
    </r.ListItem>
  );
};

Checkbox.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    isSelected: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  filterIndex: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  style: PropTypes.shape({ ...React.CSSProperties }).isRequired,
};

export default Checkbox;
